// extracted by mini-css-extract-plugin
module.exports = {"root":"Collapse_root__26_9x","entered":"Collapse_entered__rTKh5","wrapper":"Collapse_wrapper__3xIui","wrapperInner":"Collapse_wrapperInner__2gXrO"};